import { NavigationItemFragmentFragment } from '@Generated/graphql'

export function getMenuItemTitle(menuItem: NavigationItemFragmentFragment): string {
  if (menuItem.title) {
    return menuItem.title
  }

  const reference = menuItem.link?.references?.find(r => r && 'title' in r) as { title?: string } | undefined
  return reference?.title || ''
}
